module.exports = __webpack_public_path__ + "static/media/lu7.7ecef85d.png";